import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

function CreateUser() {
    const navigate = useNavigate();

    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [clientes, setClientes] = useState([]);

    // Estados para os campos do formulário
    const [razao, setRazao] = useState("");
    const [fantasia, setFantasia] = useState("");
    const [telefone1, setTelefone1] = useState("");
    const [telefone2, setTelefone2] = useState("");
    const [email, setEmail] = useState("");
    const [cliente, setCliente] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [uf, setUf] = useState("");
    const [cidade, setCidade] = useState("");
    const [cep, setCep] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [senha, setSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");

    // Estados para erros de validação
    const [errors, setErrors] = useState([]);

    // Estados para o modal de novo cliente
    const [showNovoClienteModal, setShowNovoClienteModal] = useState(false);
    const [razaoSocialCliente, setRazaoSocialCliente] = useState("");
    const [razaoError, setRazaoError] = useState("");

    useEffect(() => {
        axios
            .post("/api/auth", { withCredentials: true })
            .then((response) => {
                if (response.data.status === 200) {
                    setAuthenticated(true);
                    setUser(response.data.user);
                    setClientes(response.data.cliente);
                } else {
                    navigate("/login");
                }
            })
            .catch(() => {
                navigate("/login");
            });
    }, [navigate]);

    // Função para formatar CPF/CNPJ
    const handleInputChangeCpf = (event) => {
        const { value } = event.target;
        const newValue = value.replace(/\D/g, "");

        if (newValue.length <= 11) {
            const formattedValue = newValue.replace(
                /(\d{3})(\d{3})(\d{3})(\d{0,2})/,
                (match, p1, p2, p3, p4) => {
                    if (p4) return `${p1}.${p2}.${p3}-${p4}`;
                    return `${p1}.${p2}.${p3}`;
                }
            );
            setCpfCnpj(formattedValue);
        } else if (newValue.length <= 14) {
            const formattedValue = newValue.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/,
                (match, p1, p2, p3, p4, p5) => {
                    if (p5) return `${p1}.${p2}.${p3}/${p4}-${p5}`;
                    return `${p1}.${p2}.${p3}/${p4}`;
                }
            );
            setCpfCnpj(formattedValue);
        } else {
            setCpfCnpj(newValue);
        }
    };

    // Função para formatar números de telefone
    const handlePhoneNumberChange = (event, setPhone) => {
        const { value } = event.target;
        const newValue = value.replace(/\D/g, "");

        let formattedValue = "";
        if (newValue.length <= 10) {
            formattedValue = newValue.replace(
                /(\d{2})(\d{4})(\d{4})/,
                "($1) $2-$3"
            );
        } else {
            formattedValue = newValue.replace(
                /(\d{2})(\d{5})(\d{4})/,
                "($1) $2-$3"
            );
        }

        setPhone(formattedValue);
    };

    const handlePhoneNumberChange1 = (event) =>
        handlePhoneNumberChange(event, setTelefone1);
    const handlePhoneNumberChange2 = (event) =>
        handlePhoneNumberChange(event, setTelefone2);

    // Função para cadastrar um novo cliente
    const handleCadastrarCliente = async (event) => {
        event.preventDefault();
        if (!razaoSocialCliente.trim()) {
            setRazaoError("Por favor, digite a razão social.");
            return;
        }

        try {
            const response = await axios.post(
                "/api/new/client",
                { nome: razaoSocialCliente },
                { withCredentials: true }
            );
            if (response.data.status === 200) {
                // Sucesso: atualizar a lista de clientes e fechar o modal
                setClientes([...clientes, response.data.cliente]); // Supondo que response.data.cliente contém o novo cliente
                setShowNovoClienteModal(false);
                setRazao("");
            } else if (response.data.status === 400) {
                alert("Por favor, digite um nome!");
            } else {
                alert(response.data.status);
            }
        } catch (error) {
            alert("Algo de errado aconteceu! " + error);
        }
    };

    // Função para cadastrar um novo usuário
    const handleCadastrarUsuario = async (event) => {
        event.preventDefault();

        // Limpar erros anteriores
        setErrors([]);

        // Validações básicas
        let validationErrors = [];
        if (!razao.trim()) {
            validationErrors.push({
                elemento: "razao",
                mensagem: "Nome de usuário é obrigatório.",
            });
        }
        if (!fantasia.trim()) {
            validationErrors.push({
                elemento: "fantasia",
                mensagem: "Nome Fantasia é obrigatório.",
            });
        }
        if (!telefone1.trim()) {
            validationErrors.push({
                elemento: "telefone1",
                mensagem: "Telefone 1 é obrigatório.",
            });
        }
        if (!email.trim()) {
            validationErrors.push({
                elemento: "email",
                mensagem: "Email é obrigatório.",
            });
        }
        if (!cliente.trim()) {
            validationErrors.push({
                elemento: "cliente",
                mensagem: "Cliente é obrigatório.",
            });
        }
        if (!cpfCnpj.trim()) {
            validationErrors.push({
                elemento: "cpf_cnpj",
                mensagem: "CPF/CNPJ é obrigatório.",
            });
        }
        if (!senha.trim()) {
            validationErrors.push({
                elemento: "senha",
                mensagem: "Senha é obrigatória.",
            });
        }
        if (senha !== confirmarSenha) {
            validationErrors.push({
                elemento: "confirmar",
                mensagem: "As senhas não coincidem.",
            });
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const response = await axios.post(
                "/api/new/user",
                {
                    razao,
                    fantasia,
                    telefone: telefone1,
                    telefone2,
                    email,
                    cliente,
                    endereco,
                    numero,
                    complemento,
                    uf,
                    cidade,
                    cep,
                    cpf_cnpj: cpfCnpj,
                    senha,
                    confirmarSenha,
                },
                { withCredentials: true }
            );

            if (response.data.status === 200) {
                // Sucesso: redirecionar ou recarregar a página
                navigate("/consultar/usuarios");
            } else if (response.data.status === 400) {
                // Exibir erros retornados pela API
                setErrors(response.data.erros);
            } else {
                alert(response.data.msg);
            }
        } catch (error) {
            console.error(error);
            alert("Algo de errado aconteceu! " + error);
        }
    };

    // Renderizar o spinner de carregamento enquanto autentica
    if (!authenticated) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    // Verificar se o usuário é administrador
    if (user && user.id !== 1) {
        navigate("/bad/request");
        return null;
    }

    return (
        <>
            <section className="content">
                <div className="container-fluid" style={{ marginTop: 18 }}>
                    <div className="row center-element">
                        <h1>Cadastrando Usuário</h1>
                    </div>
                    <div id="erros">
                        {errors.map((error, index) => (
                            <div
                                key={index}
                                className="row mt-3"
                                style={{
                                    padding: "10px",
                                    borderRadius: "5px",
                                    backgroundColor: "#FFC0CB",
                                }}
                            >
                                <div style={{ display: "inline-block" }}>
                                    {error.mensagem}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={handleCadastrarUsuario}>
                                        {/* Nome de Usuário e Nome Fantasia */}
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Nome de usuário
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="nome"
                                                        className="form-control"
                                                        id="nome"
                                                        value={razao}
                                                        onChange={(e) =>
                                                            setRazao(
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "razao"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Nome Fantasia
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="nome_fantasia"
                                                        className="form-control"
                                                        id="fantasia"
                                                        value={fantasia}
                                                        onChange={(e) =>
                                                            setFantasia(
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "fantasia"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Telefone 1 e Telefone 2 */}
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Telefone 1
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={15}
                                                        value={telefone1}
                                                        onChange={
                                                            handlePhoneNumberChange1
                                                        }
                                                        name="telefone1"
                                                        id="telefone1"
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "telefone1"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label>Telefone 2</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={15}
                                                        value={telefone2}
                                                        onChange={
                                                            handlePhoneNumberChange2
                                                        }
                                                        name="telefone2"
                                                        id="telefone2"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Email e Cliente */}
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Email
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        id="email"
                                                        placeholder="meuemail@email.com"
                                                        value={email}
                                                        onChange={(e) =>
                                                            setEmail(
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "email"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Qual empresa pertence?
                                                    </label>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-success"
                                                                onClick={() =>
                                                                    setShowNovoClienteModal(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                Adicionar
                                                            </button>
                                                        </div>
                                                        <select
                                                            className="form-control"
                                                            id="cliente"
                                                            value={cliente}
                                                            onChange={(e) =>
                                                                setCliente(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            style={{
                                                                backgroundColor:
                                                                    errors.find(
                                                                        (e) =>
                                                                            e.elemento ===
                                                                            "cliente"
                                                                    )
                                                                        ? "#FFC0CB"
                                                                        : "",
                                                            }}
                                                        >
                                                            <option value="">
                                                                Selecione um
                                                                cliente
                                                            </option>
                                                            {clientes.map(
                                                                (dado) => (
                                                                    <option
                                                                        key={
                                                                            dado.id
                                                                        }
                                                                        value={
                                                                            dado.nome
                                                                        }
                                                                    >
                                                                        {
                                                                            dado.nome
                                                                        }
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Endereço, Número e Complemento */}
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label>Endereço</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="endereco"
                                                        id="endereco"
                                                        value={endereco}
                                                        onChange={(e) =>
                                                            setEndereco(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-2">
                                                <div className="form-group">
                                                    <label>N°</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="numero"
                                                        id="numero"
                                                        value={numero}
                                                        onChange={(e) =>
                                                            setNumero(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Complemento</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="complemento"
                                                        id="complemento"
                                                        value={complemento}
                                                        onChange={(e) =>
                                                            setComplemento(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* UF, Cidade e CEP */}
                                        <div className="row">
                                            <div className="col-2">
                                                <div className="form-group">
                                                    <label>U.F.</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="uf"
                                                        id="uf"
                                                        value={uf}
                                                        onChange={(e) =>
                                                            setUf(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-2">
                                                <div className="form-group">
                                                    <label>Cidade</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="cidade"
                                                        id="cidade"
                                                        value={cidade}
                                                        onChange={(e) =>
                                                            setCidade(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>CEP</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="cep"
                                                        id="cep"
                                                        value={cep}
                                                        onChange={(e) =>
                                                            setCep(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label className="required">
                                                        CPF/CNPJ
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="cpf_cnpj"
                                                        value={cpfCnpj}
                                                        onChange={
                                                            handleInputChangeCpf
                                                        }
                                                        maxLength={18}
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "cpf_cnpj"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Senha e Confirmação */}
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Senha
                                                    </label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        id="senha"
                                                        placeholder="******"
                                                        value={senha}
                                                        onChange={(e) =>
                                                            setSenha(
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "senha"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <label className="required">
                                                        Confirmar Nova Senha
                                                    </label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        id="confirmar"
                                                        placeholder="******"
                                                        value={confirmarSenha}
                                                        onChange={(e) =>
                                                            setConfirmarSenha(
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                errors.find(
                                                                    (e) =>
                                                                        e.elemento ===
                                                                        "confirmar"
                                                                )
                                                                    ? "#FFC0CB"
                                                                    : "",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Botão de Submissão */}
                                        <div className="col-md-12 text-center">
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                                id="criar"
                                            >
                                                Criar Perfil
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal para adicionar novo cliente */}
            {showNovoClienteModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block" }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <form onSubmit={handleCadastrarCliente}>
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Cadastrar Novo Cliente
                                    </h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() =>
                                            setShowNovoClienteModal(false)
                                        }
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label htmlFor="razao">
                                            Razão Social
                                        </label>
                                        <input
                                            type="text"
                                            id="razao"
                                            className="form-control"
                                            name="razao"
                                            value={razaoSocialCliente}
                                            onChange={(e) => {
                                                setRazao(
                                                    e.target.value
                                                );
                                                setRazaoError("");
                                            }}
                                            style={{
                                                backgroundColor: razaoError
                                                    ? "#FFC0CB"
                                                    : "",
                                            }}
                                        />
                                        {razaoError && (
                                            <small className="text-danger">
                                                {razaoError}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() =>
                                            setShowNovoClienteModal(false)
                                        }
                                    >
                                        Fechar
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CreateUser;
